import React from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { PageContainer, MainContent } from "../styles/PageLayoutStyle";

const PageLayout = ({ children }) => {

  return (
    <PageContainer>
      <Sidebar />
      <MainContent>
        {children}
      </MainContent>
    </PageContainer>
  );
};

export default PageLayout;
